import React from 'react';
import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import TableComponent from 'UiKit/table-component';
import { useScheduleGenerateState } from 'View/schedule-generate/state';

import buildTableList from './const';
import styles from './styles.module.css';
import { getRecapData } from 'View/schedule-generate/helper/getRecapData';

const GenerateResultRecap = () => {
  const { t } = useTranslation('schedule-generate');
  const tableList = buildTableList(t);
  const { accounts, hostsInRulesets } = useScheduleGenerateState();

  const recapData = getRecapData(accounts, hostsInRulesets);

  return (
    <Box className={styles['generate-result-recap__container']}>
      <TableComponent columns={tableList} dataSource={recapData} isDataExist={recapData?.length > 0} tableName="generate-result-recap" />
    </Box>
  );
};

export default GenerateResultRecap;
